import { jsx as n } from "react/jsx-runtime";
import { c as l } from "react/compiler-runtime";
import { TableContainer as m } from "@mui/material";
import { forwardRef as p } from "react";
const s = p((a, i) => {
  const e = l(7);
  let o, r;
  e[0] !== a ? ({
    children: o,
    ...r
  } = a, e[0] = a, e[1] = o, e[2] = r) : (o = e[1], r = e[2]);
  let t;
  return e[3] !== o || e[4] !== r || e[5] !== i ? (t = /* @__PURE__ */ n(m, { ref: i, ...r, children: o }), e[3] = o, e[4] = r, e[5] = i, e[6] = t) : t = e[6], t;
});
s.displayName = "TableContainer";
export {
  s as TableContainer
};
